import React, { useState } from "react";
import { Button } from "../Button";
import { useDispatch } from "react-redux";
import {
  setErrorMessage,
  setSuccessMessage,
} from "../../Redux/Slices/alert.slice";
import { parseApiError } from "../../Helper/apiError.helper";
import { ClassForm } from "./ClassForm";
import { useAddClass } from "../../hooks/classHooks/class.hooks";

export const AddClass = () => {
  const dispatch = useDispatch();
  const [className, setClassName] = useState("");

  const { isLoading: isAddingClass, mutate: addClass } = useAddClass({
    onSuccess: () => {
      setClassName("");
      return dispatch(setSuccessMessage("Class added successfully."));
    },
    onError: (error: any) => {
      return dispatch(setErrorMessage(parseApiError(error)));
    },
  });

  const handleAddClass = () => {
    if (!className) {
      return dispatch(setErrorMessage("Please enter class name"));
    }

    addClass({
      className,
    });
  };

  return (
    <div className="flex flex-col">
      <ClassForm className={className} setClassName={setClassName} />

      <div>
        <Button loading={isAddingClass} text="Save" onClick={handleAddClass} />
      </div>
    </div>
  );
};
